/**
 * US-A2 — shown when the handshake is rejected because the user is not an internal user
 * (`fk_user_type_id != 1`, a `403`). The tool is internal-only; there is no in-app recovery.
 */
export function AccessDenied() {
  return (
    <main className="state-screen" role="alert">
      <div className="state-card">
        <h1>Access denied</h1>
        <p>This tool is available to internal staff only.</p>
        <p className="muted-note">If you believe this is a mistake, contact your administrator.</p>
      </div>
    </main>
  );
}
